export class ItemMonitoramento {
  constructor(
    public situacao: SituacaoMonitoramento,
    public erro: string
  ) {}
}

export enum SituacaoMonitoramento {
  SUCESSO = 'SUCESSO',
  FALHA = 'FALHA',
  IGNORADO = 'IGNORADO'
}
